import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

export const contactSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().email(),
  subject: z.string(),
  message: z.string(),
  createdAt: z.date(),
  status: z.enum(["pending", "replied", "resolved"]).default("pending"),
});

export class ContactDto extends createZodDto(contactSchema) {}
